module.exports = __webpack_public_path__ + "static/media/superpowers.3ba7bbad.svg";